(function (angular, app) {
   "use strict";

   angular.module(app.modules.outing.name)
      .factory(app.modules.outing.services.outings, OutingServicesFactory);

   OutingServicesFactory.$inject = [app.modules.common.services.http, "$q"
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
   ];

   function OutingServicesFactory($http, $q
       , ggSettings
       , ggFunctions
       ) {

      var _searchTypes = {}
      var _statusTypes = {
         online: "Active"
         , offline: "Offline"
         , deleted : "Archived"
      }
      var _classTypes = {
         public: "Public"
         , private: "PrivateInvitationOnly"
      }

      var _search = {
         fetchOutingDetail: function (outingId) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.getOutingInfo;
            apipath = apipath.replace("(id)", "(" + outingId + ")");
            return $http.get(apipath, {});
         }
         , fetchOutingDetailByToken: function (tokenId) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.detailByToken;
            apipath = apipath.replace("(tokenId)",  tokenId);
            return $http.get(apipath, {});
         }
         , fetchOutingToken: function (outingId) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.getOutingToken;
            apipath = apipath.replace("(id)", "(" + outingId + ")");
            return $http.get(apipath, {});
         }
         , fetchOutingsByPlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.getOutingsByMemberId + "?$top=100&$expand=createdBy($select=firstName,lastName,photo),gameCourses,group&$orderby=startOn+desc,id+desc";
            apipath = apipath.replace("(memberId)", data.memberId);
            apipath = apipath.replace("(includeOrganizing)", !!data.includeOrganizing);
            return $http.get(apipath, {});
         }
          , findAGame: function (data) {
              var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.findAGame ;
              apipath = apipath.replace("(memberId)", data.memberId);
              return $http.get(apipath, {});
          }
         , fetchOutingsByMembership: function (frm) {

            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.group.membership;

            var qry = "?$top=100&$filter=memberId eq " + frm.memberId + " and group/isActive eq true"
            var sexp = ""
            var exp = "&$expand=group($expand=outings($expand=createdBy($select=id,firstName,lastName,photo)[[subexpand]]))";
            var ord = ""; //"&$orderby=group/outings/rounds/startOn desc";
            var is = false;

           

            exp = exp.replace("[[subexpand]]", "")


            // Fetch
            return $http.get(apipath + qry + exp + ord, {}).then(function (data) {
               var newData = {
                  status : data.status
                  , data : {
                     value : []
                  }
               }
               if (data && data.status == "200") {

                  if (data.data.value.length > 0) {
                     var memberships = data.data.value;
                     for (var m = 0; m < memberships.length; m++) {
                        if (memberships[m].group) {
                           var outings = memberships[m].group.outings;
                           for (var o = 0; o < outings.length; o++) {
                               if (outings[o].createdById != frm.memberId) {
                                   newData.data.value.push(outings[o]);
                               }
                              
                           }
                        }
                     }
                  }
               }
               return newData;
            }, function (error) {
               return error; // update Core.EntityFramework.EFValidationBugFix.cs
            });

         }
         , fetchOutingsByCreator: function (data) {

            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.search;

            var qry = "?$top=50&$filter=status ne  " + ggSettings.grpapi.namespace + ".GRPOutingStatusType'Archived'"
            var exp = "&$expand=createdBy($select=firstName,lastName,photo),rounds($select=id)";
            var ord = "&$orderby=startOn desc";

               qry += " and createdById eq " + data.createdById;
               
            return $http.get(apipath + qry + exp + ord, {});

         }
         , fetchOutings: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.search;

            var qry = "?$top=50&$filter="
            var exp = "&$expand=createdBy($select=firstName,lastName,photo)";
            var ord = "&$orderby=startOn desc"
            var is = false;

            // ?$filter=((groupId+eq+1)+or+(groupId+eq+2))&$expand=createdBy($select=firstName,lastName),group($select=name,type),gameCourses($select=id,courseId,name,number)

            // Individual grup
            if (data.groupId && data.groupId > 0) {
               if (is) {
                  qry += " and ";
               }
               qry += " groupId eq " + data.groupId;
               is = true;
            }
            // List of groups
            if (data.groupIdList && data.groupIdList.length > 0) {
               if (is) {
                  qry += " and ";
               }
               qry += "("
               for (var g = 0; g < data.groupIdList.length; g++) {
                  if (g > 0) {
                     qry += " or "
                  }
                  qry += " (groupId eq " + data.groupIdList[g] + ")"
               }
               qry += ")"
               is = true;
            }

            // Created By Id
            if (data.createdById) {
               if (is) {
                  qry += " and ";
               }
               qry += " createdById eq " + data.createdById;
               is = true;
            }


            if (data.startOn) {
               if (is) {
                  qry += " and ";
               }
               qry += " startOn gt " + ggFunctions.formatDateString(data.startOn, 'yyyy-mm-dd', null);
               is = true;
            }
            if (data.endOn) {
               if (is) {
                  qry += " and ";
               }
               qry += " startOn lt " + ggFunctions.formatDate(data.endOn, 'yyyy-mm-dd', null);
               is = true;
            }
            if (data.class) {
               if (is) {
                  qry += " and ";
               }
               qry += " class eq " + ggSettings.grpapi.namespace + ".GRPOutingClassType'" + data.class + "'";
               is = true;
            }
            if (data.status) {
               if (is) {
                  qry += " and ";
               }
               qry += " status eq " + ggSettings.grpapi.namespace + ".GRPOutingStatusType'" + data.status + "'";
               is = true;
            } else {
               if (is) {
                  qry += " and ";
               }
               qry += " status eq " + ggSettings.grpapi.namespace + ".GRPOutingStatusType'Active'";
               is = true;
            }

            return $http.get(apipath + qry + exp + ord, {});

         }
      }
   
      var _course = {
            fetchCourses: function (data) {
               var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.courses;
               apipath = apipath.replace("(id)", "(" +data.outingId + ")");
               var qry = "";
               if (data.courseId && data.courseId > 0) {
                  qry += "?$filter=id eq " +data.courseId + "&";
               } else {
                  qry += "?";
                  }

               var exp = "$expand=gameTees($expand=gameHoles)"
               return $http.get(apipath + qry + exp, { });
               }
            , insertCourse: function (data) {
            var apipath = ggSettings.grpapi.root +ggSettings.grpapi.outing.courses;
               apipath = apipath.replace("(id)", "(" +data.outingId + ")");

               var form = { };
               form.outingId = data.outingId;
               form.number = data.number;
               form.type = data.course.type
               form.name = data.course.name;

            form.courseId = data.course.id;
            form.facilityName = data.course.name;
            form.phone = null; //data.course.phone;

            form.address = data.course.address
            return $http.post(apipath, form, false);
            }
         , insertCourseFull: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.addGameCourse;
            apipath = apipath.replace("(id)", "(" +data.outingId + ")");
            var form = {
                  courseId : data.courseId
                  }
               return $http.post(apipath, form);
            }
         , tees : {
                  insertTee: function(data) {
               var apipath = ggSettings.grpapi.root +ggSettings.grpapi.outing.tees;
               apipath = apipath.replace("(id)", "(" +data.outingId + ")");
               var form = { };
               form.grpCourseId = data.gameCourseId;
               form.teeboxScorecardId = data.tee.id;
               form.type = data.tee.type
               form.name = data.tee.name;

               form.rating = data.tee.rating;
               form.slope = data.tee.slope;

               form.frontRating = data.tee.frontRating;
               form.frontSlope = data.tee.frontSlope;
               form.backRating = data.tee.backRating;
               form.backSlope = data.tee.backSlope;

                  // Post the data, but don't transform it.
                  return $http.post(apipath, form, false);
            }
            , insertHole: function(data) {
               var apipath = ggSettings.grpapi.root +ggSettings.grpapi.outing.holes;
               apipath = apipath.replace("(id)", "(" +data.outingId + ")");
               var form = {
               };
               form.grpTeeId = data.gameTeeId;
               form.holeId = data.hole.id;
               form.number = data.hole.number;
                  form.name = data.hole.name || "Hole #"+ data.hole.number;

                  form.par = data.hole.par;
               form.handicap = data.hole.handicap;
               form.yardage = data.hole.yardage;

                  // Post the data, but don't transform it.
                  return $http.post(apipath, form, false);
                  }
               }
               }

      var _round = {
         fetchRounds: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.rounds;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var qry = "?";
            var exp = "$expand=teeTimes($expand=teams,players($select=id,teamId,teamOrder,handicap,effectiveOn,handicapType,isHandicapAdjusted;$expand=member($select=id,networkId,firstName,lastName,gender,photo)))"
            return $http.get(apipath + qry + exp, {});
         }
         , insertRound: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.rounds;
            apipath = apipath.replace("(id)", "("+data.outingId+")");
            var form = {};
            form.name = data.name;
            form.number = data.number
            form.outingId = data.outingId
            form.startOn = data.startOn
            form.endOn = data.endOn
            return $http.post(apipath, form, false);
         }
         , updateRound: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.rounds + "(" + data.roundId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.name = data.name;
            form.number = data.number
            //form.outingId = data.outingId
            form.startOn = data.startOn
            form.endOn = data.endOn
            return $http.put(apipath, form, false);
         }
         , deleteRound: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.rounds + "(" + data.roundId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            return $http.delete(apipath, null);
         }
         
      }

      var _teetime = {
         fetchTeeTimes : function(data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var qry = "?$filter=roundId eq " + data.roundId;
            var exp = "&$expand=teams,players($select=id,teamId,teamOrder;$expand=member($select=id,networkId,firstName,lastName,gender,photo))"
            return $http.get(apipath + qry + exp, {});
         }
         , fetchTeeTimeDetail: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes + "("+data.teeTimeId+")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var qry = "?";
            var exp = "$expand=gameCourse($expand=gameTees($expand=gameHoles)),players($select=id,teamId,teamOrder;$expand=member($select=id,networkId,firstName,lastName,gender,photo)),round"
            return $http.get(apipath + qry + exp, {});
         }
         , insertTeeTime : function(data){
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.roundId = data.roundId;
            form.gameCourseId = data.gameCourseId;
            form.startingTime = data.startingTime;
            form.startingHole = data.startingHole;
            form.teeTimeNumber = data.teeTimeNumber; // Should always be one unless we are shotgunning multiple groups per tee time.
            return $http.post(apipath, form, false);
         }
         , updateTeeTime: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes + "(" + data.teeTimeId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.roundId = data.roundId;
            form.gameCourseId = data.gameCourseId;
            form.startingTime = data.startingTime;
            form.startingHole = data.startingHole;
            form.teeTimeNumber = data.teeTimeNumber; // Should always be one unless we are shotgunning multiple groups per tee time.
            return $http.put(apipath, form);
         }
         , deleteTeeTime: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes + "(" + data.teeTimeId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            
            return $http.delete(apipath, {});
         }
         , addPlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes + "(" + data.teeTimeId + ")/players/$ref";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {
               "@odata.id": ggSettings.grpapi.root + "outings(" + data.outingId + ")/players(" + data.playerId + ")"
            }
            return $http.post(apipath, form, false);
         }
         , updatePlayerOrder: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.setTeeTimeOrder;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            apipath = apipath.replace("(teeTimeId)", "(" + data.teeTimeId + ")");
            var form = {
               playerId: data.playerId
               , teeTimeOrder : data.teeTimeOrder
            }
            return $http.post(apipath, form, false);
         }
         , deletePlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teetimes + "(" + data.teeTimeId + ")/players(" + data.playerId + ")/$ref";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            return $http.delete(apipath, form);
         }
         , addTeam: function (data) {
            var apipath = ggSettings.grpapi.root +ggSettings.grpapi.outing.teetimes + "(" + data.teeTimeId + ")/teams/$ref";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {
               "@odata.id": ggSettings.grpapi.root + "outings(" + data.outingId + ")/teams(" +data.teamId + ")"
               }
            return $http.post(apipath, form, false);
         }
         , deleteTeam: function (data) {
            var apipath = ggSettings.grpapi.root +ggSettings.grpapi.outing.teetimes + "(" + data.teeTimeId + ")/teams(" +data.teamId + ")/$ref";
            apipath = apipath.replace("(id)", "(" +data.outingId + ")");
            var form = { };
            return $http.delete(apipath, form);
         }
      }

      var _player = {
         fetchPlayers: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.players;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var qry = "";
            if (data.memberId && data.memberId > 0) {
               qry += "?$filter= memberId eq " + data.memberId + "&";
            } else {
               qry += "?";
            }
            var exp = "$expand=member($select=id,networkId,firstName,lastName,email,gender,dateOfBirth,photo)"
            return $http.get(apipath + qry + exp, {});
         }
         , insertPlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.players;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.outingId = data.outingId;
            form.memberId = data.memberId;

            if (data.handicap) {
               form.handicap = data.handicap;
            }
            if (data.effectiveOn) {
               form.effectiveOn = data.effectiveOn;
            }

            return $http.post(apipath, form, false);
         }
         , updatePlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.players + "(" + data.playerId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            return $http.put(apipath, data.form);
         }
         , deletePlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.players + "(" + data.playerId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            return $http.delete(apipath, form);
         }
         , autoJoinOuting: function (data) {

            var outingId = data.outingId;
            var memberId = data.memberId;
            var handicap = data.handicap;
            var effectiveOn = data.effectiveOn

            var isOK = true;
            var rval = {
               status: "400"
               , statusMsg: ""
               , data: {
                  outingId: outingId
                  , memberId: memberId
                  , playerId: 0
               }
            }

            // Fetch
            var _fetch = function(){
               return _player.fetchPlayers({ outingId: outingId, memberId: memberId }).then(function (data) {
                  if (data && data.status == "200") {
                     if (data.data.value.length > 0) {
                        rval.data.playerId = data.data.value[0].playerId;
                     }
                  }
                  return;
               }, function (error) {
                  isOK = false;
                  rval.status = "There was an error fetching the member information.";
                  return;
               })
            };
            // Insert
            var _insert = function () {
               return _player.insertPlayer({ outingId: outingId, memberId: memberId, handicap: handicap, effectiveOn: effectiveOn }).then(function (data) {
                  if (data && data.status == "201") {
                     rval.status = "201";
                     rval.statusMsg = "The player was added.";
                     rval.data.playerId = data.data.id;
                  }
                  return;
               }, function (error) {
                  isOK = false;
                  rval.status = "There was an error inserting the player information.";
                  return;
               });
            }
            // Update
            var _update = function () {
               return _player.updatePlayer({ outingId: outingId, playerId: rval.data.playerId, isActive: true, handicap: handicap }).then(function (data) {
                  if (data && data.status == "200") {
                     rval.status = "200";
                     rval.statusMsg = "The player was added.";
                  }
                  return;
               }, function (error) {
                  isOK = false;
                  rval.statusMsg = "There was an error updating the player information.";
               });
            }

            // Process
            return _fetch().then(function (data) {
               if (isOK){
                  if (rval.data.playerId > 0) {
                     return _update();
                  } else {
                     return _insert();
                  }
               }
            }).then(function () {
               return rval;
            });

         }
      }

      var _game = {
         fetchGames: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var qry = "";
            var exp = "?$expand=teams($expand=players),players($expand=member($select=id,networkId,firstName,lastName,gender,photo)),rounds($select=id)"; //&$expand=teeTimePlayers"
            return $http.get(apipath + qry + exp, {});
         }
         , insertGame: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.outingId = data.outingId;
            form.isMain = data.isMain;
            form.name = data.name;
            form.gameType = data.gameType;
            form.holeType = data.holeType;
            form.scoringType = data.scoringType;
            form.pointType = data.pointType;
            form.isNet = data.isNet;
            form.isLowHandicap = data.isLowHandicap;
            form.isSkins = data.isSkins;
            form.isWager = data.isWager;
            form.maxSkinStrokes = data.maxSkinStrokes;
            form.points = data.points;
            form.bestBalls = data.bestBalls;

            if (form.pointType == "None") {
               form.pointType = null;
            }

            return $http.post(apipath, form, false);
         }
         , updateGame: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games + '(' + data.id + ')';
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.outingId = data.outingId;
            form.isMain = data.isMain;
            form.name = data.name;
            form.gameType = data.gameType;
            form.holeType = data.holeType;
            form.scoringType = data.scoringType;
            form.isNet = data.isNet;
            form.isLowHandicap = data.isLowHandicap;
            form.isSkins = data.isSkins;
            form.isWager = data.isWager;
            form.maxSkinStrokes = data.maxSkinStrokes;
            form.pointType = data.pointType;
            form.bestBalls = data.bestBalls;
            form.points = data.points;

            if (form.pointType == "None") {
               form.pointType = null;
            }
            return $http.put(apipath, form);
         }
         , deleteGame: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games + '(' + data.id + ')';
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            return $http.delete(apipath, {});
         }
         , addPlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games + "(" + data.gameId + ")/players/$ref";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {
               "@odata.id": ggSettings.grpapi.root + "outings(" + data.outingId + ")/players(" + data.playerId + ")"
            }
            return $http.post(apipath, form, false);
         }
         , deletePlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games + "(" + data.gameId + ")/players(" + data.playerId + ")/$ref";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            return $http.delete(apipath, {});
         }
         , addTeam: function (data) {
            var apipath = ggSettings.grpapi.root +ggSettings.grpapi.outing.games + "(" + data.gameId + ")/teams/$ref";
               apipath = apipath.replace("(id)", "(" + data.outingId + ")");
               var form = {
               "@odata.id" : ggSettings.grpapi.root + "outings(" +data.outingId + ")/teams(" +data.teamId + ")"
               }
            return $http.post(apipath, form, false);
         }
         , deleteTeam: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games + "(" + data.gameId + ")/teams(" + data.teamId + ")/$ref";
            apipath = apipath.replace("(id)", "(" +data.outingId + ")");
            return $http.delete(apipath, {});
         }
         , addRound: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games + "(" + data.gameId + ")/rounds/$ref";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {
               "@odata.id": ggSettings.grpapi.root + "outings(" + data.outingId + ")/rounds(" + data.roundId + ")"
            }
            return $http.post(apipath, form, false);
         }
         , deleteRound: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.games + "(" + data.gameId + ")/rounds(" + data.roundId + ")/$ref";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            return $http.delete(apipath, {});
         }
      }

      var _team = {
         fetchTeams: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teams;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var qry = "?";
            var exp = "$expand=players($select=id,teamId,teamOrder,handicap,effectiveOn,handicapType,isHandicapAdjusted;$expand=member($select=id,networkId,firstName,lastName,gender,photo))"
            return $http.get(apipath + qry + exp, {});
         }
         , fetchTeamDetail: function (data) {
            var apipath = ggSettings.grpapi.root +ggSettings.grpapi.outing.teams + "(" +data.teamId + ")";
            apipath = apipath.replace("(id)", "(" +data.outingId + ")");
            var qry = "?";
            var exp = "$expand=players($select=id,teamId,teamOrder,handicap,effectiveOn,handicapType,isHandicapAdjusted;$expand=member($select=id,networkId,firstName,lastName,gender,photo))"
            return $http.get(apipath + qry +exp, { });
         }
         , insertTeam: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teams;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.outingId = data.outingId;
            form.name = data.name;
            form.sortOrder = data.sortOrder;
            return $http.post(apipath, form, false);
         }
         , deleteTeam: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teams + "(" + data.teamId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            return $http.delete(apipath, {});
          }
         , updateTeam: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.teams + "(" +data.teamId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.outingId = data.outingId;
            form.name = data.name;
            form.sortOrder = data.sortOrder;
            return $http.put(apipath, form);
         }
         , updatePlayer: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.players + "(" + data.playerId + ")";
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};

            form.outingId = data.outingId;

            if (data.teamId) {
               form.teamId = data.teamId;
               if (data.teamOrder) {
                     form.teamOrder = data.teamOrder;
                  } else {
                     form.teamOrder = null
               }
            } else {
               form.teamId = null;
               form.teamOrder = null;
            }
            
            return $http.put(apipath, form);
         }
         
      }

      var _setup = {
         insertOuting: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.insert;
            var form = {};
            form.name = data.name;
            form.description = data.description
            if (data.isActive) {
               form.status = "Active"
            } else {
               form.status = "Offline"
            }
            form.class = data.classType
            form.createdById = app.Member.Detail.id;
            form.groupId = parseInt(data.groupId);
            form.themeId = data.themeId;
            form.handicapType = data.handicapType;
            return $http.post(apipath, form, false);
         }
         , updateOuting: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.detail;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {};
            form.id = data.outingId;
            form.name = data.name;
            form.description = data.description;
            form.status = data.status;
            form.class = data.classType;
            form.themeId = data.themeId;
            form.groupId = data.groupId;
            form.handicapType = data.handicapType;
            return $http.put(apipath, form, false);
         }
         , updateHandicaps: function (data) {
            var apipath = ggSettings.grpapi.root + ggSettings.grpapi.outing.updatehandicaps;
            apipath = apipath.replace("(id)", "(" + data.outingId + ")");
            var form = {
               revisionDate : null
            };
            return $http.post(apipath, form, false);
         }
      }

      var service = {
         searchTypes: _searchTypes
         , statusTypes: _statusTypes
         , classTypes : _classTypes
         , search: _search
         , setup: _setup
         , player: _player
         , course: _course
         , teetime: _teetime
         , round: _round
         , game: _game
         , team: _team
      }

      return service;
   }
}(angular, app));

